<template>
    <div class="cabinet-content-wrap">
        <header class="cabinet-header flex flex-align-center">
            <h1 class="h1 cabinet-title">
                {{ user ? `Привет, ${user.name}!` : '' }}
            </h1>
        </header>

        <invitation
            title="Приглашайте ваших партнеров на площадку"
            descr="Пригласите партнеров-оптовиков на площадку, и система
                автоматически оповестит их о выкладываемых новинках, а обратная
                связь от них позволит Вам оперативно корректировать
                ассортиментную программу производства и формировать заказы в
                межвыставочный период."
        />

        <!-- <chart-stats /> -->

        <!-- <top-stats /> -->

        <product-types-stats />

        <brands-stats />

        <!-- <gn-stats /> -->

        <useful-links />
    </div>
</template>

<script>
import Invitation from '@/components/Elements/Invitation'
import ChartStats from '@/components/Cabinet/Supplier/Dashboard/ChartStats'
import TopStats from '@/components/Cabinet/Supplier/Dashboard/TopStats'
import ProductTypesStats from '@/components/Cabinet/Supplier/Dashboard/ProductTypesStats'
import BrandsStats from '@/components/Cabinet/Supplier/Dashboard/BrandsStats'
// import GnStats from '@/components/Cabinet/Supplier/Dashboard/GnStats'
import UsefulLinks from '@/components/Cabinet/Supplier/Dashboard/UsefulLinks'
import { mapState } from 'vuex'

export default {
    name: 'SupplierDashboard',
    components: {
        //ChartStats,
        //TopStats,
        Invitation,
        ProductTypesStats,
        BrandsStats,
        // GnStats,
        UsefulLinks
    },
    data() {
        return {}
    },
    computed: {
        ...mapState('user', ['user'])
    }
}
</script>
